class ModalityOptions {
    /**
     * Creates a ModalityOption object to force the current window into full screen mode
     * @returns {{name: string}} - Object to send into `applyModalityOptions()`
     */
    static forceFullScreen() {
        return {
            name: 'forceFullScreen'
        };
    }

    /**
     * Creates a ModalityOption object to disable new tabs, and whitelisting allowed domains to navigate
     * @param {string[]} whitelistedUrls - Array of URLs that need to be accessible during the exam
     * @returns {{whitelistedUrls: {string}[], name: string}} - Object to send into `applyModalityOptions()`
     */
    static disableNewTabs(whitelistedUrls = []) {
        return {
            name: 'disableNewTabs',
            whitelistedUrls
        }
    }

    /**
     * Creates a ModalityOption object to disable the chrome context menu from appearing when right clicking
     * @returns {{name: string}} - Object to send into `applyModalityOptions()`
     */
    static disableRightClick() {
        return {
            name: 'disableRightClick'
        }
    }

    /**
     * Creates a ModalityOption object to make anything printed come out blank
     * @returns {{name: string}} - Object to send into `applyModalityOptions()`
     */
    static disablePrinting() {
        return {
            name: 'disablePrinting'
        }
    }

    /**
     * Creates a ModalityOption object to disable copy and paste
     * @returns {{name: string}} - Object to send into `applyModalityOptions()`
     */
    static disableClipboard() {
        return  {
            name: 'disableClipboard'
        }
    }

    /**
     * Creates a ModalityOption object to block certain extensions
     * @param {{id:string}[]|null} [whitelistedExtensions] - Array of whitelisted extension objects
     * @returns {{whitelistedExtensions: {id:string, name:string, description:string}[]|[], name: string}} - Object to send into `applyModalityOptions()`
     */
    static blockExtensions(whitelistedExtensions = []) {
        return {
            name: 'blockExtensions',
            whitelistedExtensions
        }
    }

    static enforceSingleDisplay() {
        return {
            name: 'enforceSingleDisplay'
        }
    }
}

module.exports = ModalityOptions;